export const isEnabled = modal => Boolean(modal && typeof modal === 'object' && modal.isEnabled);
export const generateModal = (modal, content, name) => isEnabled(modal) && content && name ? {
  ...modal,
  content,
  isEnabled: true,
  name
} : null;
//# sourceMappingURL=modal.js.map